export default __webpack_public_path__ + "static/media/2.a3951ba0.png";